export const checkEveryPermissions = (arr1, arr2) => {
  return arr1?.every(el => arr2?.includes(el));
};

export const checkSomePermissions = (arr1, arr2) => {
  return arr1?.some(el => arr2?.includes(el));
};
